import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "redux"
import { translate } from "react-i18next"
import uniqid from "uniqid"
import styled from "styled-components"
import { lighten } from "polished"
import { Scrollbars } from "react-custom-scrollbars"

const RadioLabel = styled.label`
  font-size: 14px !important;
  color: #777 !important;
  margin: 2px 0 !important;
  font-weight: normal !important;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")} !important;
  &:before {
    animation: none !important;
  }
  &:after {
    border-color: ${props => lighten(0.2, props.primaryColor)} !important;
    background-color: ${props => props.primaryColor} !important;
  }

  &:hover:before {
    background-color: ${props =>
    (props.disabled ? "transparent" : lighten(0.5, props.primaryColor))} !important;
  }
`

const RadioButton = styled.input`
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")} !important;
`

class RadioList extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
    })).isRequired,
    sortAlphabetically: PropTypes.bool,
    translateLabels: PropTypes.bool,
    verticalScrollSize: PropTypes.number,
    theme: PropTypes.shape({
      primaryColor: PropTypes.string.isRequired,
      primaryColorHover: PropTypes.string.isRequired,
      navBackgroundColor: PropTypes.string.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    sortAlphabetically: false,
    translateLabels: false,
    verticalScrollSize: 100,
  }

  componentWillMount = () => {
    this.controlId = `radios_${uniqid()}`
  }

  handleRadioChange = (e) => {
    this.props.onChange(e.target.value)
  }

  render() {
    const {
      t,
      options,
      translateLabels,
      verticalScrollSize,
      theme,
      sortAlphabetically,
    } = this.props

    const groupName = `radios_${this.controlId}`

    let optionCollection = options.map((opt) => {
      return { item: opt, text: translateLabels ? t(opt.label) : opt.label }
    })

    if (sortAlphabetically) {
      optionCollection = optionCollection.sort((a, b) => a.text.localeCompare(b.text))
    }

    const radioListItems = optionCollection.map((opt) => {
      const radioId = `chk_${this.controlId}_${opt.item.value}`
      return (
        <div key={`${opt.item.value}_${opt.item.label}`}>
          <RadioButton
            type="radio"
            className="with-gap"
            id={radioId}
            name={groupName}
            value={opt.item.value}
            onChange={this.handleRadioChange}
            checked={opt.item.selected}
            disabled={opt.item.disabled}
          />
          <RadioLabel
            htmlFor={radioId}
            primaryColor={theme.primaryColor}
            disabled={opt.item.disabled}
          >
            {opt.text}
          </RadioLabel>
        </div>
      )
    })

    return (
      <Scrollbars
        autoHeight
        autoHeightMin={20}
        autoHeightMax={verticalScrollSize}
        renderTrackHorizontal={props => (
          <div {...props} style={{ display: "none" }} className="track-horizontal" />
        )}
      >
        {radioListItems}
      </Scrollbars>
    )
  }
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(translate(), connect(mapStateToProps))(RadioList)



// WEBPACK FOOTER //
// ./src/components/inputs/RadioList.jsx